/** Prismic `status_overall` values for a game. */
export const OVERALL_STATUS = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  ACTIVE_BUT_NOT_DISPLAYED: 'Active but not displayed',
  ACTIVE_BUT_BETTING_DISABLED: 'Active but betting disabled',
} as const;

const ALLOWED_OVERALL_STATUSES: ReadonlySet<string> = new Set([
  OVERALL_STATUS.ACTIVE,
  OVERALL_STATUS.ACTIVE_BUT_NOT_DISPLAYED,
  OVERALL_STATUS.ACTIVE_BUT_BETTING_DISABLED,
]);

/**
 * A `null`/`undefined` status (not yet resolved) is allowed, as are the active
 * variants. Anything else (e.g. `Inactive`) means the game is disabled.
 */
export const isOverallStatusAllowed = (
  status: string | null | undefined,
): boolean => status == null || ALLOWED_OVERALL_STATUSES.has(status);
